export const heroStats = [
  { value: '128', unit: '条', label: '今日新增话题' },
  { value: '36', unit: '个', label: '进行中热搜' },
  { value: '2.4', unit: '万', label: '在线讨论人数' },
  { value: '7', unit: '分钟', label: '平均更新间隔' },
];

export const heroTicker = [
  '20:12 新话题进入热搜区，时间线已同步',
  '19:48 社区补充三条现场物料，正在复核',
  '19:05 相关方发布简短说明，已归档到时间线',
  '18:30 昨日话题热度回落，讨论区转为复盘',
  '17:55 新增话题标签「片场花絮」，可一口气看完',
  '16:40 编辑组完成今日新瓜第一批整理',
];

export const todayMelons = [
  {
    id: 'm1',
    size: 'large',
    tag: '头条 · 今日新瓜',
    title: '古装新剧杀青现场花絮流出，三条支线剧情被网友拼成完整脉络',
    excerpt:
      '从路人拍摄的收工画面到主创团队晒出的合照，社区把零散片段按时间顺序排好，前后对得上，结论也更清楚。',
    time: '12 分钟前更新',
    reads: '3.8 万',
    comments: '412',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20for%20an%20entertainment%20news%20feature%20about%20a%20drama%20filming%20set%2C%20warm%20cream%20and%20soft%20crimson%20tones%2C%20minimal%20geometric%20shapes%2C%20subtle%20grain%20texture%2C%20clean%20negative%20space%2C%20no%20text%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20flat%20soft%20lighting&width=1200&height=800&seq=hl-melon-01&orientation=landscape',
  },
  {
    id: 'm2',
    size: 'small',
    tag: '热搜',
    title: '综艺录制现场互动被拍，名场面被逐帧复盘',
    excerpt: '一段十几秒的现场画面，讨论区拆成了七八个观察点。',
    time: '26 分钟前',
    reads: '1.9 万',
    comments: '208',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20a%20variety%20show%20stage%20light%20cone%20in%20warm%20gold%20and%20deep%20red%20on%20a%20cream%20background%2C%20geometric%20editorial%20style%2C%20soft%20grain%2C%20no%20text%2C%20no%20people%2C%20clean%20negative%20space&width=800&height=600&seq=hl-melon-02&orientation=landscape',
  },
  {
    id: 'm3',
    size: 'small',
    tag: '联名',
    title: '联名新品未发先火，设计稿在社区被逐张对比',
    excerpt: '配色与前代差在哪，网友做了张对照表。',
    time: '51 分钟前',
    reads: '1.2 万',
    comments: '96',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20a%20brand%20collaboration%20packaging%20box%20in%20warm%20terracotta%20and%20cream%20tones%2C%20editorial%20flat%20style%2C%20clean%20negative%20space%2C%20soft%20grain%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=hl-melon-03&orientation=landscape',
  },
  {
    id: 'm4',
    size: 'small',
    tag: '演出',
    title: '音乐节返场加场消息确认，抢票时间线被整理',
    excerpt: '开票节点、退改规则，一条线看完不踩坑。',
    time: '1 小时前',
    reads: '9800',
    comments: '73',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20a%20music%20festival%20stage%20silhouette%20with%20warm%20amber%20glow%20on%20cream%20background%2C%20editorial%20geometric%20style%2C%20soft%20grain%20texture%2C%20no%20text%2C%20no%20people%2C%20clean%20composition&width=800&height=600&seq=hl-melon-04&orientation=landscape',
  },
  {
    id: 'm5',
    size: 'small',
    tag: '短剧',
    title: '短剧赛道再出黑马，主创团队回应观众疑问',
    excerpt: '评论区高频问题被整理成答疑清单。',
    time: '2 小时前',
    reads: '7600',
    comments: '54',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20minimal%20illustration%20of%20stacked%20film%20frames%20and%20abstract%20ribbon%20shapes%20in%20warm%20crimson%20and%20amber%20on%20cream%2C%20editorial%20flat%20style%2C%20soft%20grain%2C%20no%20text%2C%20no%20people&width=800&height=600&seq=hl-melon-05&orientation=landscape',
  },
];

export const timelineEvents = [
  {
    time: '09:12',
    tag: '话题出现',
    title: '一条模糊现场图在社区被首次转发',
    text: '图片信息量有限，讨论区先按「待确认」处理，只记录不扩散。',
  },
  {
    time: '10:40',
    tag: '物料补充',
    title: '第二段路人拍摄画面出现，细节开始对得上',
    text: '与上午的图片比对后，时间、地点、服装细节相互吻合，可信度上调。',
  },
  {
    time: '12:05',
    tag: '相关方回应',
    title: '相关方发布简短说明，未展开细节',
    text: '说明被原文归档，同时标注了发布渠道与时间，方便后续核对。',
  },
  {
    time: '14:30',
    tag: '二次讨论',
    title: '社区拆解回应内容，列出三个待补充的点',
    text: '讨论聚焦「还缺什么」，而不是急着下结论，问题清单被顶到前排。',
  },
  {
    time: '17:20',
    tag: '补充说明',
    title: '补充材料被整理进时间线，前因后果串起来',
    text: '从最早话题出现到此刻，关键节点已收拢成一条可回溯的链路。',
  },
  {
    time: '20:00',
    tag: '复盘完成',
    title: '今日话题时间线归档，进入下次更新的观察队列',
    text: '归档后仍会继续跟进，有新节点会在原时间线上续写，不另开入口。',
  },
];

export const rollingLeaks = [
  {
    time: '20:12',
    tag: '热搜',
    tone: 'primary',
    title: '新话题进入热搜区，站内时间线同步完成',
    source: '编辑组整理',
    likes: '1.2k',
    comments: '88',
  },
  {
    time: '19:48',
    tag: '社区',
    tone: 'secondary',
    title: '讨论区补充三条现场物料，正在逐条复核来源',
    source: '社区投稿',
    likes: '860',
    comments: '64',
  },
  {
    time: '19:05',
    tag: '回应',
    tone: 'accent',
    title: '相关方发布简短说明，已原文归档到时间线',
    source: '公开渠道',
    likes: '2.4k',
    comments: '310',
  },
  {
    time: '18:30',
    tag: '复盘',
    tone: 'secondary',
    title: '昨日话题热度回落，讨论区转为整体复盘模式',
    source: '编辑组整理',
    likes: '540',
    comments: '41',
  },
  {
    time: '17:55',
    tag: '标签',
    tone: 'primary',
    title: '新增话题标签「片场花絮」，可一口气看完同源内容',
    source: '编辑组整理',
    likes: '1.7k',
    comments: '126',
  },
  {
    time: '16:40',
    tag: '更新',
    tone: 'accent',
    title: '今日新瓜第一批整理完成，共 12 条进入热点区',
    source: '编辑组整理',
    likes: '930',
    comments: '52',
  },
];

export const communityTalks = [
  {
    id: 'c1',
    name: '瓜田老农',
    badge: '时间线爱好者',
    avatarTone: 'secondary',
    time: '18 分钟前',
    topic: '#古装新剧花絮',
    content:
      '建议大家先看时间线再看讨论，顺序一换，很多「看不懂」的点自己就通了。我把三次更新的节点都存了书签，回头补线很快。',
    likes: 328,
    replies: 42,
  },
  {
    id: 'c2',
    name: '夜观风向',
    badge: '理性吃瓜',
    avatarTone: 'accent',
    time: '37 分钟前',
    topic: '#综艺名场面',
    content:
      '现场画面只有十几秒，讨论区给出了好几个解释。我的建议是：先把能确认的和不能确认的分开摆，别急着站队。',
    likes: 214,
    replies: 30,
  },
  {
    id: 'c3',
    name: '前排小板凳',
    badge: '滚动爆料追踪',
    avatarTone: 'primary',
    time: '1 小时前',
    topic: '#联名设计稿',
    content:
      '这次的对照表做得挺细，配色、材质、包装结构都标了。唯一想补充的是，未发布的内容还是等官方图更稳。',
    likes: 176,
    replies: 18,
  },
];

export const trustPoints = [
  {
    icon: 'ri-link-m',
    title: '来源标注',
    text: '每条内容都尽量标出来源与发布时间，方便自己判断，也方便回头核对。',
  },
  {
    icon: 'ri-history-line',
    title: '时间线复核',
    text: '新节点会续写在原有时间线上，不新开入口，保证前因后果能连起来。',
  },
  {
    icon: 'ri-error-warning-line',
    title: '纠错通道',
    text: '发现内容有误可在讨论区指出，编辑组会标注修正并保留原始记录。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容边界',
    text: '不收录涉及个人隐私与非公开信息的内容，示范性话题仅用于展示版式。',
  },
];

export const faqs = [
  {
    q: '黑料在线的内容都是怎么来的？',
    a: '以社区投稿与公开渠道信息为主，编辑组做整理、标注来源并复核发布时间。首页展示的话题为示范内容，用于说明版式与结构，不代表真实事件。',
  },
  {
    q: '首页真的 24 小时都在更新吗？',
    a: '热点区与滚动爆料流会按节奏持续补新，平均更新间隔大约几分钟。夜间节奏会放慢，但已有话题的时间线不会中断，第二天仍可顺着看。',
  },
  {
    q: '「时间线」到底有什么用？',
    a: '时间线把同一个话题的关键节点按发生顺序排好。你可以从最早的一条看起，一路补到最新，不用来回翻入口，也不用担心看漏中间发生了什么。',
  },
  {
    q: '发现内容有误或者信息不完整怎么办？',
    a: '在对应话题的讨论区里说明即可，编辑组会复核并标注修正。修正不会悄悄替换原文，而是保留记录并注明更改时间，让后来的人也能看懂。',
  },
  {
    q: '怎么参与社区讨论？',
    a: '在讨论区写清你的观察角度就好，比如「这条我没看明白哪一点」或者「我补充一个能对上的细节」。理性的补充比情绪化的结论更受欢迎。',
  },
];

export const footerColumns = [
  {
    title: '浏览',
    links: ['今日新瓜', '事件时间线', '滚动爆料', '社区热议'],
  },
  {
    title: '规则',
    links: ['内容声明', '纠错通道', '隐私说明', '示范内容说明'],
  },
  {
    title: '关于',
    links: ['站点介绍', '更新节奏', '联系我们', '加入整理'],
  },
];